import React, { useEffect, useState, forwardRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Card, CardContent, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Modal, Divider, CardHeader, Radio, FormControl, FormLabel, FormControlLabel, RadioGroup } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import axios from 'axios';
import './Learn.css';
import { useHistory } from 'react-router';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Cookies from 'universal-cookie';
//<span className="imageContainer"> <img className="imageC" src="/imgLearn.png" alt="learning" /></span>
const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const useStyles = makeStyles(theme => ({
    mainFeaturedPost: {
        position: 'relative',
        backgroundColor: theme.palette.grey[800],
        color: theme.palette.common.white,
        marginBottom: theme.spacing(4),
        marginTop: '11vh',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        height: '250px',
    },
    pageContent: {
        margin: theme.spacing(5),
        padding: theme.spacing(3),
        textAlign: 'center'
    },
    cardQuiz: {
        margin: theme.spacing(3),
        padding: theme.spacing(3),
        textAlign: 'left'
    },
    overlay: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0,.3)',
    },
    mainFeaturedPostContent: {
        position: 'relative',
        padding: theme.spacing(3),
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(6),
            paddingRight: 0,
        },
        icon: {
            marginRight: theme.spacing(2),
        },
        heroContent: {
            backgroundColor: theme.palette.background.paper,
            padding: theme.spacing(8, 0, 6),
        },
        heroButtons: {
            marginTop: theme.spacing(4),
        },
        cardGrid: {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8),

        },
        card: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',

        },
        cardMedia: {
            paddingTop: '56.25%',

        },
        cardContent: {
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#f5f5f5',
        },
        footer: {
            backgroundColor: theme.palette.background.paper,
            padding: theme.spacing(6),
        },

    },
}));


function MainContent() {
    const cookies = new Cookies();
    const userToken = cookies.get('tokenCTF');
    const [info, setInfo] = useState([]);
    const [quiz, setQuiz] = useState([]);
    const history = useHistory();
    const [openSuccess, setOpenSuccess] = useState(false);
    const [openError, setOpenError] = useState(false);
    const [error, setErrorMessage] = useState('');
    const [success, setSuccessMessage] = useState('');
    const [showQuiz, setShowQuiz] = useState(true);
    const [question0, setQuestion0] = useState(0);
    const [question1, setQuestion1] = useState(0);
    const [question2, setQuestion2] = useState(0);
    const [question3, setQuestion3] = useState(0);
    const [question4, setQuestion4] = useState(0);
    const [answer0, setAnswer0] = useState('');
    const [answer1, setAnswer1] = useState('');
    const [answer2, setAnswer2] = useState('');
    const [answer3, setAnswer3] = useState('');
    const [answer4, setAnswer4] = useState('');
    const [levelQuiz, setLevelQuiz] = useState('');
    const [userScore, setUserScore] = useState('');
    const [openScoreDialog, setopenScoreDialog] = useState(false);
    const [changeCategoryQuiz, setChangeCategoryQuiz] = useState(false);
    useEffect(() => {
        axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/learning/getCategories`, {
            headers: { 'Authorization': userToken }
        }).then(res => {
            if (res.data.noAuth) {
                cookies.remove('tokenCTF', { path: '/' });
                history.push('/login');
            }
            else {
                if (res.data.categories) {
                    setInfo(res.data.categories);
                    setShowQuiz(res.data.showQuiz);
                    setChangeCategoryQuiz(false);
                }
                else {
                    setQuiz(res.data.quiz);
                    setShowQuiz(res.data.showQuiz);
                    setQuestion0(res.data.quiz[0].question_id)
                    setQuestion1(res.data.quiz[1].question_id)
                    setQuestion2(res.data.quiz[2].question_id)
                    setQuestion3(res.data.quiz[3].question_id)
                    setQuestion4(res.data.quiz[4].question_id)
                    setLevelQuiz(res.data.quiz[0].level)
                    setChangeCategoryQuiz(false);
                }

            }

        })

    }, [changeCategoryQuiz]);
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenError(false);
            return;
        }
    }
    const changeAnswer = (question, answer) => {
        if (question == 0) {
            setAnswer0(answer);
        }
        else if (question == 1) {
            setAnswer1(answer);
        }
        else if (question == 2) {
            setAnswer2(answer);
        }
        else if (question == 3) {
            setAnswer3(answer);
        }
        else if (question == 4) {
            setAnswer4(answer);
        }

    }
    const sendQuiz = () => {
        if (!answer0 || !answer1 || !answer2 || !answer3 || !answer4) {
            setErrorMessage('Debes responder todas las preguntas para continuar');
            setOpenError(true);
        }
        else {
            axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/learning/solveQuiz`, {
                question1: question0,
                question2: question1,
                question3: question2,
                question4: question3,
                question5: question4,
                answer1: answer0,
                answer2: answer1,
                answer3: answer2,
                answer4: answer3,
                answer5: answer4,

            }, {
                headers: { 'Authorization': userToken }
            }).then((response) => {
                if (response.data.noAuth) {
                    cookies.remove('tokenCTF', { path: '/' });
                    history.push('/login');
                }
                else {
                    if (response.data.messageScore) {
                        setUserScore(response.data.messageScore);
                        setopenScoreDialog(true);
                    }
                    else if (response.data.messageError) {
                        setErrorMessage(response.data.messageError)
                        setOpenError(true)
                    }
                    else {
                        setErrorMessage('');
                        setOpenError(false);
                        setSuccessMessage('');
                        setOpenSuccess(false);
                    }
                }
            })
        }
    }
    const handleCloseDialogScore = () => {
        setopenScoreDialog(false);
        setChangeCategoryQuiz(true);
    };
    const classes = useStyles();

    if (showQuiz == true) {
        return <><Paper className="pageContent">

            <h1>Prueba de Nivel {levelQuiz}</h1>
            <Divider />
            <br />
            {quiz.map((value, key) => (
                <Card className="cardQuiz" key={key}>
                    <h3>{value.question}</h3>
                    <br />
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Seleccione la respuesta correcta</FormLabel>
                        <RadioGroup
                            aria-label="gender"
                            defaultValue=""
                            name="radio-buttons-group"
                            onChange={(e) => { changeAnswer(key, e.target.value) }}
                        >
                            <FormControlLabel value={value.answers.split(',')[0]} control={<Radio />} label={value.answers.split(',')[0]} />
                            <FormControlLabel value={value.answers.split(',')[1]} control={<Radio />} label={value.answers.split(',')[1]} />
                            <FormControlLabel value={value.answers.split(',')[2]} control={<Radio />} label={value.answers.split(',')[2]} />
                            <FormControlLabel value={value.answers.split(',')[3]} control={<Radio />} label={value.answers.split(',')[3]} />
                        </RadioGroup>
                    </FormControl>
                </Card>
            ))}
            <Button variant="contained" color="primary" onClick={sendQuiz}>Enviar</Button>
        </Paper>
            <Snackbar open={openError} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="error" className="alertWidthTop">
                    {error}
                </Alert>
            </Snackbar>
            <Snackbar open={openSuccess} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success" className="alertWidthTop">
                    {success}
                </Alert>
            </Snackbar>
            <Dialog
                open={openScoreDialog}
                onClose={handleCloseDialogScore}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Puntaje del cuestionario"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <h1>{`Tu puntaje es: ` + userScore + '/5'}</h1>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialogScore} autoFocus>
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    }
    else {
        return <Grid container spacing={4}>
            {info.map((value, key) => (
                <Grid item key={key} xs={12} sm={5} className="gridMarginLearn">
                    <Card className="cardLearn card2Learn" onClick={(e) => {
                        history.push('/user/aprendizaje/' + value.category_id)
                    }}>
                        <CardContent className="cardContentStylingLearn">

                            <img src={value.location} alt="learning" className="imgStylingLearn" />
                            <div>
                                <Typography gutterBottom variant="h4" className="typographyStyling1">
                                    {value.title}
                                </Typography>

                                <Typography className="typographyStyling2">
                                    {value.description}
                                </Typography>
                            </div>

                        </CardContent>
                        <div className="divStylingLearn">Módulos: {value.modules ? value.modules : 0}</div>

                    </Card>
                </Grid>
            ))}
        </Grid>
    }
}
export default function MainFeaturedPost(props) {
    const classes2 = useStyles();
    const history = useHistory();
    const { post } = props;



    return (
        <div className='learn-user'>
            <Paper className="mainFeaturedPost" >
                <div className="overlay" />
                <Grid container>
                    <Grid item md={6}>
                        <div className="mainFeaturedPostContent">
                            <Typography component="h1" variant="h3" color="inherit" gutterBottom>
                                Sección de aprendizaje
                            </Typography>
                            <Typography variant="h5" color="inherit" paragraph>
                                Aquí podrás aprender sobre diferentes temas del área de la ciberseguridad.
                            </Typography>
                        </div>
                    </Grid>

                </Grid>

            </Paper>

            <MainContent />

        </div>
    );
}